var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgList = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.75c0-.91.548-1.73 1.389-2.08.84-.347 1.808-.154 2.452.49.643.643.836 1.61.488 2.451C3.98 20.452 3.16 21 2.25 21 1.008 21 0 19.992 0 18.75zM2.25 4.5c.91 0 1.73-.548 2.08-1.389.347-.84.154-1.808-.49-2.452C3.198.016 2.23-.177 1.39.171.548.52 0 1.34 0 2.25 0 3.492 1.008 4.5 2.25 4.5zm0 8.25c.91 0 1.73-.548 2.08-1.389.347-.84.154-1.808-.49-2.452-.643-.643-1.61-.836-2.451-.488C.548 8.77 0 9.59 0 10.5c0 1.242 1.008 2.25 2.25 2.25zm7.684-9h12.632c.93 0 1.684-.672 1.684-1.5s-.754-1.5-1.684-1.5H9.934c-.93 0-1.684.672-1.684 1.5s.754 1.5 1.684 1.5zm0 8.25h12.632c.93 0 1.684-.672 1.684-1.5S23.496 9 22.566 9H9.934c-.93 0-1.684.672-1.684 1.5S9.004 12 9.934 12zm0 8.25h12.632c.93 0 1.684-.672 1.684-1.5s-.754-1.5-1.684-1.5H9.934c-.93 0-1.684.672-1.684 1.5s.754 1.5 1.684 1.5z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgList, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/list.1106fcc3.svg";
export { ForwardRef as ReactComponent };